import axios from 'axios'

/*const request = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  withCredentials: true,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.REACT_APP_API_URL}`,
    'Content-Type': 'application/json',
  },
})*/

/*function request(token) {
  return axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    withCredentials: true,
    headers: {
      'Access-Control-Allow-Origin': `${process.env.REACT_APP_API_URL}`,
      'Content-Type': 'application/json',
      //'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  })
}*/

function request(token) {
  return axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    withCredentials: true,
    headers: {
      //'Access-Control-Allow-Origin': `${process.env.REACT_APP_API_URL}`,
      'Content-Type': 'application/json',
      //'Content-Type': 'multipart/form-data',
      Authorization: token ? `Bearer ${token}` : undefined,
    },
  })
}

export default request
